import { useField } from '../hooks';
import { tariff } from '../paths';
export var useTariff = function () { return useField(tariff); };
